import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatDateTime } from "@/lib/format";
import { formatRelative } from "./activityResources";

/** "3 days ago", with the exact time on hover or focus. */
export function RelativeTime({ value, prefix = "" }: { value: string | null | undefined; prefix?: string }) {
  if (!value) return <span className="text-muted-foreground">Never</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time dateTime={value} tabIndex={0} className="cursor-default underline decoration-dotted decoration-from-font underline-offset-2">
          {prefix}
          {formatRelative(value)}
        </time>
      </TooltipTrigger>
      <TooltipContent>{formatDateTime(value)}</TooltipContent>
    </Tooltip>
  );
}
